import React from 'react';
import { createStyles, Grid, makeStyles } from '@material-ui/core';

import {
  CoverageCatalog,
  Quotation,
  QuotationCoverage,
} from 'data-layer-cr/dist/models';
import { deductibleCoverages } from 'data-layer-cr/dist/functions/coverages';
import {
  SubTitle1Text,
  H4Text,
  colors,
  moneyFormat,
  HeaderText,
  Slider,
  DisplayItem,
} from 'design-system';

const useStyles = makeStyles(() =>
  createStyles({
    deductibleName: {
      color: colors.abbey,
      textTransform: 'uppercase',
    },
  }),
);

const { formatMoney } = moneyFormat;

type Props = {
  productCoverages: QuotationCoverage[];
  catalogCoverages: CoverageCatalog[];
  deductibleOptions?: DisplayItem[];
  quotation: Quotation;
};

const QuotationDeductibles = ({
  productCoverages,
  catalogCoverages,
  deductibleOptions,
  quotation,
}: Props): JSX.Element => {
  const classes = useStyles();

  const deductibleCoverageList = deductibleCoverages(catalogCoverages);
  const filteredProductDeductibles = productCoverages.filter((coverage) =>
    deductibleCoverageList.find((deduc) => deduc.code === coverage.coverageId),
  );
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SubTitle1Text>Deducibles</SubTitle1Text>
      </Grid>
      {filteredProductDeductibles.map((deductible) => {
        const currentDeductible = deductibleCoverageList.find(
          (cov) => cov.code === deductible.coverageId,
        ) as CoverageCatalog;

        return (
          <Grid container item xs={12} key={deductible.coverageId}>
            <Grid item xs={12}>
              <H4Text
                className={classes.deductibleName}
                data-testid={`deductible-${deductible.coverageId}-name`}
              >
                {currentDeductible.name}
              </H4Text>
            </Grid>
            <Grid item xs={12}>
              <HeaderText
                data-testid={`deductible-${deductible.coverageId}-text`}
              >
                {formatMoney(
                  deductible.deductible,
                  false,
                  quotation.quotationProfile.typeOfMoney,
                )}
              </HeaderText>
            </Grid>
          </Grid>
        );
      })}
      {deductibleOptions && (
        <Grid
          item
          xs={12}
          style={{ paddingRight: 19, paddingLeft: 7 }}
          data-testid="deductible-slider-container"
        >
          <Slider
            options={deductibleOptions}
            inputName="deductibles"
            labelType="all"
            data-testid="deductible-slider"
          />
        </Grid>
      )}
    </Grid>
  );
};

export default QuotationDeductibles;
